import ReValidate from './../re-validation'
import props from './../../../../props/inputs'

export default {
  name: 're-textarea',
  components: {[ReValidate.name]: ReValidate},
  props,
  methods: {
    onInput(event) {
      const value = event.target.value
      this.$emit('input', value)
    },
  },
}
